(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!window.bbReviewsMore) {
    window.bbReviewsMore = true;
    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-bb-more]') : null;
      if (!button) return;
      const root = button.closest('.bb-rev-sec');
      if (!root) return;
      if (button.dataset.bbMore === 'photos') {
        root.querySelectorAll('.bb-rev__tile[hidden]').forEach((tile) => {
          tile.hidden = false;
        });
        button.hidden = true;
        return;
      }
      const waiting = Array.from(root.querySelectorAll('.bb-rev[hidden]'));
      const step = Number(button.dataset.step) || 5;
      waiting.slice(0, step).forEach((card) => {
        card.hidden = false;
      });
      if (waiting.length <= step) button.hidden = true;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-carousel')) {
    customElements.define(
      'bb-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.bb-car__track');
          if (!this.track) return;
          this.originals = Array.from(this.track.children);
          this.speed = Number(this.dataset.speed) || 30;
          this.wantsLoop =
            this.hasAttribute('data-autoplay') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.holdUntil = 0;
          this.hovered = false;
          this.visible = true;
          this.setWidth = 0;

          this.onClick = (event) => {
            const button = event.target instanceof Element ? event.target.closest('[data-dir]') : null;
            if (!button || !this.contains(button)) return;
            this.hold(5000);
            const dir = Number(button.dataset.dir);
            const item = this.originals[0];
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            const stepSize = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
            const perPage = Math.max(1, Math.floor((this.track.clientWidth * 0.85) / stepSize));
            const step = dir * perPage * stepSize;
            if (this.setWidth) {
              if (dir < 0 && this.track.scrollLeft + step < this.setWidth * 0.5) this.jump(this.setWidth);
              if (dir > 0 && this.track.scrollLeft + step > this.setWidth * 1.5) this.jump(-this.setWidth);
            }
            this.track.scrollBy({ left: step, behavior: 'smooth' });
          };
          this.onScroll = () => {
            this.update();
            window.clearTimeout(this.settleTimer);
            this.settleTimer = window.setTimeout(() => this.normalize(), 160);
          };
          this.onResize = () => this.setup();
          this.onBlockSelect = (event) => {
            if (!this.contains(event.target)) return;
            const item = event.target;
            this.track.scrollTo({
              left: item.offsetLeft - (this.track.clientWidth - item.offsetWidth) / 2,
              behavior: 'smooth',
            });
          };

          this.addEventListener('click', this.onClick);
          this.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') this.hovered = true;
          });
          this.addEventListener('pointerleave', () => {
            this.hovered = false;
          });
          this.addEventListener('pointerdown', () => this.hold(4000));
          this.addEventListener('wheel', () => this.hold(3000), { passive: true });
          this.addEventListener('touchstart', () => this.hold(4000), { passive: true });
          this.addEventListener('focusin', () => this.hold(6000));
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize);
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver((entries) => {
              this.visible = entries.some((entry) => entry.isIntersecting);
            });
            this.observer.observe(this);
          }

          this.setup();
          window.setTimeout(() => this.setup(), 800);
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.onResize);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          if (this.observer) this.observer.disconnect();
          if (this.frame) window.cancelAnimationFrame(this.frame);
        }

        hold(ms) {
          this.holdUntil = Math.max(this.holdUntil, performance.now() + ms);
        }

        jump(delta) {
          const behavior = this.track.style.scrollBehavior;
          this.track.style.scrollBehavior = 'auto';
          this.track.scrollLeft += delta;
          this.track.style.scrollBehavior = behavior;
          this.pos = this.track.scrollLeft;
        }

        setup() {
          const overflowing = () => this.track.scrollWidth - this.track.clientWidth > 2;
          if (this.wantsLoop && !this.setWidth) {
            this.clones = [];
            // Copies make the row loop without an end; they are hidden from screen readers.
            if (overflowing()) {
              const before = document.createDocumentFragment();
              const after = document.createDocumentFragment();
              this.originals.forEach((item) => {
                [before, after].forEach((fragment) => {
                  const copy = item.cloneNode(true);
                  copy.removeAttribute('data-shopify-editor-block');
                  copy.setAttribute('aria-hidden', 'true');
                  copy.setAttribute('inert', '');
                  copy.querySelectorAll('img').forEach((img) => img.setAttribute('loading', 'eager'));
                  fragment.appendChild(copy);
                  this.clones.push(copy);
                });
              });
              this.track.prepend(before);
              this.track.append(after);
              this.setAttribute('data-loop', '');
            }
          }
          if (this.hasAttribute('data-loop')) {
            const first = this.originals[0];
            const firstCopyAfter = this.clones[1];
            this.setWidth = firstCopyAfter && first ? firstCopyAfter.offsetLeft - first.offsetLeft : 0;
            if (this.setWidth > 0 && this.setWidth < this.track.clientWidth) {
              // Not enough photos to fill the row: drop the copies and show a still row.
              this.clones.forEach((copy) => copy.remove());
              this.clones = [];
              this.removeAttribute('data-loop');
              this.setWidth = 0;
              this.wantsLoop = false;
            } else if (this.setWidth > 0 && this.pos === undefined) {
              this.jump(this.setWidth);
            }
          }
          this.update();
          if (this.setWidth && !this.frame) this.tick();
        }

        normalize() {
          if (!this.setWidth) return;
          const left = this.track.scrollLeft;
          if (left < this.setWidth * 0.5) this.jump(this.setWidth);
          else if (left > this.setWidth * 1.5) this.jump(-this.setWidth);
        }

        tick() {
          let last = performance.now();
          const step = (now) => {
            const dt = Math.min(now - last, 64);
            last = now;
            const idle = !this.hovered && now > this.holdUntil && this.visible && !document.hidden;
            if (idle && this.setWidth) {
              if (this.pos === undefined || Math.abs(this.track.scrollLeft - this.pos) > 3) {
                this.pos = this.track.scrollLeft;
              }
              this.pos += (this.speed * dt) / 1000;
              if (this.pos > this.setWidth * 1.5) this.pos -= this.setWidth;
              this.track.scrollLeft = this.pos;
            }
            this.frame = window.requestAnimationFrame(step);
          };
          this.frame = window.requestAnimationFrame(step);
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.toggleAttribute('data-static', max <= 0);
          const prev = this.querySelector('.bb-car__btn--prev');
          const next = this.querySelector('.bb-car__btn--next');
          if (this.setWidth) {
            if (prev) prev.disabled = false;
            if (next) next.disabled = false;
            return;
          }
          if (prev) prev.disabled = this.track.scrollLeft <= 2;
          if (next) next.disabled = this.track.scrollLeft >= max;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbl-alert"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bbl-evergreen')) {
    customElements.define(
      'bbl-evergreen',
      class extends HTMLElement {
        connectedCallback() {
          const total = parseInt(this.dataset.seconds || '0', 10) * 1000;
          if (!total) return;
          const key = 'bbl-evergreen:' + (this.dataset.key || 'timer') + ':' + total;
          const now = Date.now();
          let start = now;
          try {
            const saved = parseInt(window.localStorage.getItem(key) || '', 10);
            if (saved && saved <= now && (now - saved < total || this.dataset.restart !== 'true')) start = saved;
            window.localStorage.setItem(key, String(start));
          } catch (error) {
            /* Storage blocked: the timer starts fresh on each visit. */
          }
          this.end = start + total;
          this.parts = ['h', 'm', 's'].map((k) => this.querySelector(`[data-${k}]`));
          this.tick = this.tick.bind(this);
          this.tick();
          this.timer = window.setInterval(this.tick, 1000);
        }
        disconnectedCallback() {
          window.clearInterval(this.timer);
        }
        tick() {
          let left = Math.max(0, Math.round((this.end - Date.now()) / 1000));
          if (left === 0 && this.dataset.restart === 'true') {
            this.end = Date.now() + parseInt(this.dataset.seconds || '0', 10) * 1000;
            left = Math.round((this.end - Date.now()) / 1000);
          }
          const h = Math.floor(left / 3600);
          const m = Math.floor((left % 3600) / 60);
          const s = left % 60;
          [h, m, s].forEach((value, i) => {
            if (this.parts[i]) this.parts[i].textContent = String(value).padStart(2, '0');
          });
          if (left === 0) window.clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
